import * as types from "../../actions/systemlevel/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.FETCH_CALCULATION_METHOD_OPTIONS_LIST:
      return action.payload.data;
    default:
      return state;
  }
}
